function formatDate(date) {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function calculateDates(container) {
  if (!container) return; // Prevent running if container doesn't exist
  
  let now = new Date();
  let orderToday = new Date();

  let readyDelay = 0;
  let deliveryDelay = 0;

  if (container.classList.contains('club-order')) {
    readyDelay = 1;
    deliveryDelay = 0;
  } else if (container.classList.contains('custom-print')) {
    readyDelay = 2;
    deliveryDelay = 1;
  }

  let readyStart = new Date(now);
  readyStart.setDate(now.getDate() + (now.getHours() < 12 ? readyDelay : readyDelay + 1));

  let readyEnd = new Date(readyStart);
  readyEnd.setDate(readyStart.getDate() + 1);

  let deliveryStart = new Date(readyStart);
  deliveryStart.setDate(readyStart.getDate() + 4 + deliveryDelay);

  let deliveryEnd = new Date(readyStart);
  deliveryEnd.setDate(readyStart.getDate() + 5 + deliveryDelay);

  container.querySelector("#ordertoday").innerText = formatDate(orderToday);
  container.querySelector("#orderready").innerText = `${formatDate(readyStart)} - ${formatDate(readyEnd)}`;
  container.querySelector("#orderdelivery").innerText = `${formatDate(deliveryStart)} - ${formatDate(deliveryEnd)}`;
}

function observeDynamicCt() {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = function (mutationsList) {
    for (const mutation of mutationsList) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Ensure it's an element
          if (node.classList.contains('order-delivery')) {
            calculateDates(node);
          }
          node.querySelectorAll('.order-delivery').forEach(container => calculateDates(container));
        }
      });
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// Run script only for each section separately
document.querySelectorAll('.order-delivery').forEach(container => calculateDates(container));
observeDynamicCt();

function initializeOrderTimer() {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentDay = now.getDay(); 
  const dispatchTime = 12; 
  let deadline, message;

  const todayDeadline = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    dispatchTime,
    0,
    0
  );

  if (currentDay === 6 && currentHour >= 12 && currentHour < 24) {
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0,
      0,
      0
    ); 
    deadline = midnight;
    message = `
      Order within <span class="tmr-hour">{hours}</span>  
      <span class="tmr-minute">{minutes}</span> for 
      <span class="tmr-tdy">One-day Dispatch*</span>
    `;
  } else if (currentDay === 0) {
    deadline = new Date(todayDeadline.getTime() + 1 * 24 * 60 * 60 * 1000); 
    message = `
      Order within <span class="tmr-hour">{hours}</span>  
      <span class="tmr-minute">{minutes}</span> for 
      <span class="tmr-tdy">Next-day Dispatch*</span>
    `;
  } else if (currentHour < 12) {
    deadline = todayDeadline;
    message = `
      Order within <span class="tmr-hour">{hours}</span>  
      <span class="tmr-minute">{minutes}</span> for 
      <span class="tmr-tdy">Same-day Dispatch*</span>
    `;
  } else if (currentHour >= 12 && currentHour < 24) {
    const nextDay = new Date(todayDeadline.getTime() + 24 * 60 * 60 * 1000); 
    deadline = new Date(nextDay.setHours(0, 0, 0, 0)); 
    message = `
      Order within <span class="tmr-hour">{hours}</span>  
      <span class="tmr-minute">{minutes}</span> for 
      <span class="tmr-tdy">Next-day Dispatch*</span>
    `;
  }

  function updateCountdown() {
    const now = new Date();
    const remainingTime = deadline - now;

    if (remainingTime > 0) {
      const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
      const hourLabel = hours === 1 ? "hr" : "hrs";
      const minuteLabel = minutes === 1 ? "min" : "mins";

      let formattedMessage = message;
      formattedMessage = formattedMessage
        .replace("{hours}", hours > 0 ? `${hours} ${hourLabel}` : "")
        .replace("{minutes}", minutes > 0 ? `${minutes} ${minuteLabel}` : "");

      const orderMessageElement = document.querySelectorAll("#order-message");
      orderMessageElement.forEach((element) => {
        element.innerHTML = formattedMessage.trim();
      });
    } else {
      location.reload(); 
    }
  }

  setInterval(updateCountdown, 1000);
  updateCountdown();
}
function observeDynamicContent() {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const orderTimerElement = mutation.target.querySelector("#order-timer");
        if (orderTimerElement) {
          initializeOrderTimer();
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
initializeOrderTimer();

observeDynamicContent();


window.addEventListener('load', function() {
      // Add a 3-second delay before showing the button
      setTimeout(function() {
          document.querySelectorAll('.product-customize-atcc').forEach(function(button) {
              button.classList.remove('hidden');
          });
      }, 3750); // 3000 milliseconds = 3 seconds
  });